"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhoto = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _Image = require("../Image/Image");
var _PropertyCard = require("../PropertyCard/PropertyCard.context");
var _PropertyCardPhotoFallback = require("../PropertyCardPhotoFallback/PropertyCardPhotoFallback");
var _PropertyCardPhoto = require("./PropertyCardPhoto.styles");
var _excluded = ["alt", "fallbackImg", "src", "srcSet", "sizes", "draggable"];
/**
 * Used to display a single property photo in a `PropertyCard`.
 *
 * @since 8.63.0
 */
var PropertyCardPhoto = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var alt = _ref.alt,
    fallbackImg = _ref.fallbackImg,
    src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    draggable = _ref.draggable,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_PropertyCard.PropertyCardContext);
  var ImageComponent = src ? /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt,
    "aria-hidden": "false",
    draggable: draggable
  }) : fallbackImg;
  return /*#__PURE__*/_react.default.createElement(_PropertyCardPhoto.StyledPropertyCardPhoto, (0, _extends2.default)({
    appearance: context.appearance,
    photoSrc: src,
    ref: forwardedRef
  }, rest), ImageComponent);
});
exports.PropertyCardPhoto = PropertyCardPhoto;
PropertyCardPhoto.displayName = 'PropertyCard.Photo';
PropertyCardPhoto.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The image to display if no photo is available.
   *
   * Takes a component that is displayed if no `src` value is provided.
   */
  fallbackImg: _propTypes.default.node,
  /**
   * Determines how to display the photo. Vertically-oriented photos get special
   * treatment to ensure they fill their container.
   *
   * If the photo is square, use ‘portrait’.
   */
  photoOrientation: _propTypes.default.oneOf(Object.values(_constants.PHOTO_ORIENTATIONS)),
  /**
   * The URL of the property photo, Google Street View image or satellite image.
   * If none is provided, the `fallbackImg` is displayed instead.
   */
  src: _propTypes.default.string,
  /**
   * The optional `scrset` of the image to support responsive images.
   * If none is provided, the `srcset` is not rendered.
   */
  srcSet: _propTypes.default.string,
  /**
   * The optional `sizes` of the image to support responsive images.
   * If none is provided, the `sizes` is not rendered.
   */
  sizes: _propTypes.default.string,
  /**
   * Indicates whether the image can be dragged, either with native browser behavior
   * or the HTML Drag and Drop API.
   *
   * If no value is provided, 'draggable' defaults to 'auto'
   */
  draggable: _propTypes.default.oneOf(Object.values(_constants.DRAGGABLE_VALUES))
} : {};
PropertyCardPhoto.defaultProps = {
  fallbackImg: /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoFallback.PropertyCardPhotoFallback, null),
  photoOrientation: _constants.PHOTO_ORIENTATIONS.LANDSCAPE,
  src: '',
  srcSet: '',
  sizes: '',
  draggable: _constants.DRAGGABLE_VALUES.AUTO
};